export default __webpack_public_path__ + "static/media/guide0101_m.7ad5de0d.jpg";